import { inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

export interface NavigationUrls {
    fromUrl: string;
    toUrl: string;
}

@Injectable({
  providedIn: 'root'
})
export class PreviousRouteService {
  private router = inject(Router);

  // The currently active url
  private currentUrl: string;

  emptyNavUrls: NavigationUrls = {} as NavigationUrls;

  // The "return to" url
  previousUrl = '';
  previousUrl$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  navigationUrls$ = new BehaviorSubject<NavigationUrls>(this.emptyNavUrls);

  constructor() {
    const router = this.router;

    this.currentUrl = this.router.url;
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;

        const purl = this.previousUrl;
        this.previousUrl$.next(purl);

        this.navigationUrls$.next({
          fromUrl: purl,
          toUrl: this.currentUrl
        });
      }
    });
  }

  /*
    warning....
      this code is very fragile
      if there are changes in url definitions it may break
      it depends on keywords in the urls to determine the return url target
     */
  processBiographicsAlertsRouteEvent(navUrls: NavigationUrls): any {
    const fromUrl = navUrls.fromUrl;
    const toUrl = navUrls.toUrl;

    let previousUrl: string;
    let linkLabelText: string;

    const ac = this.isAlertContext(fromUrl, toUrl);

    if (fromUrl && fromUrl.indexOf('alert') > -1) {
      previousUrl = '/alerts';
      linkLabelText = 'Alerts';
    } else {
      if (!ac) {
        previousUrl = '/biographics';
        linkLabelText = 'Submit';
      } else {
        previousUrl = '/alerts';
        linkLabelText = 'Alerts';
      }
    }

    return {
      newPreviousUrl: previousUrl,
      newLinkLabelText: linkLabelText
    };
  }

  // cases to detect we are in alerts context:
  // 1. the url we nav from ends with 'review'
  // 2. the url we nav to ends with 'review',
  // 3. the url we nav to contains 'alert'
  // -- because the submits view never has alerts to review (the alerts tab should always be disabled),
  // the submit view only has the biographics edit tab active
  // note: the routing is overloaded and used in tab navigation,
  // and this should be refactored / redesigned into a cleaner implementation
  isAlertContext(fromUrl, toUrl) {
    return fromUrl.endsWith('/review') || toUrl.endsWith('/review') || toUrl.indexOf('alert') > -1;
  }


}
